export default __webpack_public_path__ + "static/media/at.6809f4b3.svg";